import type { Claim } from '../types';
import { StanceBadge } from './StanceBadge';
import { onCitationClick } from '../audio/player';

function formatTimestamp(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
}

export function ClaimList({ claims }: { claims: Claim[] }) {
  if (claims.length === 0) return null;
  return (
    <ul className="claim-list">
      {claims.map((c) => (
        <li key={c.id}>
          <header className="claim-card-head">
            <span className="speaker">{c.speaker_name ?? 'unknown speaker'}</span>
            <StanceBadge stance={c.stance} confidence={c.confidence} />
          </header>
          <p className="claim-text">{c.claim_text}</p>
          <p className="claim-excerpt">{c.raw_excerpt}</p>
          <footer className="claim-card-foot">
            <button
              className="play-link"
              onClick={() => onCitationClick({
                episode_id: c.episode_id,
                start_sec: c.start_sec,
                end_sec: c.end_sec,
                label: `${c.speaker_name ?? 'unknown'} — ${formatTimestamp(c.start_sec)}`,
              })}
            >
              {formatTimestamp(c.start_sec)}
            </button>
            {c.topics.length > 0 && (
              <span className="topics">
                {c.topics.slice(0, 4).map((t) => (
                  <span key={t} className="topic-tag">{t}</span>
                ))}
              </span>
            )}
            {c.evidence_cited && (
              <span className="evidence">cites <em>{c.evidence_cited}</em></span>
            )}
          </footer>
        </li>
      ))}
    </ul>
  );
}
